import { render } from "./Edit.vue?vue&type=template&id=4bcff97f"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/homeWorks/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bcff97f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bcff97f', __exports__)) {
    console.log('reload')
    api.reload('4bcff97f', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=4bcff97f", () => {
    console.log('re-render')
    api.rerender('4bcff97f', render)
  })

}


export default __exports__